import { render } from "./CustomerDocumentsTimeline.vue?vue&type=template&id=a55f911c&scoped=true&ts=true&lang=pug"
import script from "./CustomerDocumentsTimeline.vue?vue&type=script&lang=ts"
export * from "./CustomerDocumentsTimeline.vue?vue&type=script&lang=ts"

import "./CustomerDocumentsTimeline.vue?vue&type=style&index=0&id=a55f911c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55f911c"]])

export default __exports__